import { isSupportedCountry } from "../../../libphonenumber-js/es6/metadata.js";
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike) {
    it && (o = it);
    var i = 0;
    return function() {
      return i >= o.length ? { done: !0 } : { done: !1, value: o[i++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray(o, minLen) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
}
function _arrayLikeToArray(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function sortCountryOptions(options, order) {
  if (!order)
    return options;
  for (var optionsOnTop = [], optionsOnBottom = [], appendTo = optionsOnTop, _loop = function() {
    var element = _step.value;
    if (element === "|")
      appendTo.push({
        divider: !0
      });
    else if (element === "..." || element === "…")
      appendTo = optionsOnBottom;
    else {
      var countryCode;
      element === "🌐" ? countryCode = void 0 : countryCode = element;
      var index = options.indexOf(options.filter(function(option2) {
        return option2.value === countryCode;
      })[0]), option = options[index];
      options.splice(index, 1), appendTo.push(option);
    }
  }, _iterator = _createForOfIteratorHelperLoose(order), _step; !(_step = _iterator()).done; )
    _loop();
  return optionsOnTop.concat(options).concat(optionsOnBottom);
}
function getSupportedCountryOptions(countryOptions, metadata) {
  if (countryOptions && (countryOptions = countryOptions.filter(function(option) {
    switch (option) {
      case "🌐":
      case "|":
      case "...":
      case "…":
        return !0;
      default:
        return isCountrySupportedWithError(option, metadata);
    }
  }), countryOptions.length > 0))
    return countryOptions;
}
function isCountrySupportedWithError(country, metadata) {
  return isSupportedCountry(country, metadata) ? !0 : (console.error("Country not found: ".concat(country)), !1);
}
function getSupportedCountries(countries, metadata) {
  return countries && (countries = countries.filter(function(country) {
    return isCountrySupportedWithError(country, metadata);
  }), countries.length === 0 && (countries = void 0)), countries;
}
export {
  getSupportedCountries,
  getSupportedCountryOptions,
  isCountrySupportedWithError,
  sortCountryOptions
};
//# sourceMappingURL=countries.js.map
